exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js?{\"modules\":true,\"importLoaders\":1,\"localIdentName\":\"[name]_[local]_[hash:base64:5]\"}!../../../node_modules/postcss-loader/lib/index.js??postcss!../../fonts.css"), undefined);

// module
exports.push([module.id, ".CardType_cardContent_AscBz {\n  margin: 1.5rem 0 0.19rem 0.3rem;\n}\n\n.CardType_last44ccNum_YLUcz {\n}\n", ""]);

// exports
exports.locals = {
	"cardContent": "CardType_cardContent_AscBz",
	"last44ccNum": "CardType_last44ccNum_YLUcz " + require("-!../../../node_modules/css-loader/index.js?{\"modules\":true,\"importLoaders\":1,\"localIdentName\":\"[name]_[local]_[hash:base64:5]\"}!../../../node_modules/postcss-loader/lib/index.js??postcss!../../fonts.css").locals["proximaNovaBold"] + ""
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]_[local]_[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/containers/Modals/CardType.css
// module id = 1090
// module chunks = 0